import React from 'react';
import './Experience.css';

import TabsContent from '../Shared/TabsContent.js';
import Tabs from '../Shared/Tabs.js';

const experience = [
  {
    label: 'Present',
    year: 'Nov 2016',
    title: 'Al Tayer Group',
    subtitle: 'Frontend developer / Visual Web Developer',
    description: '',
    url: 'http://www.bondinco.com/',
    logo: 'http://bondinco.com/wp-content/uploads/2015/11/bondinco-header22.png'
  }, {
    label: 'Got Oppertunity',
    year: 'Aug 2015',
    title: 'Bond Internet Consultancy',
    subtitle: 'Frontend developer & UX / UI Designer',
    description: 'Lead UI developer responsible for builds in Angular and Adobe Experience Manager. Subscribed to modern workflows including automation via grunt, BEM implementation via SASS, and version control via Git. Trained in agile by AgencyAgile and thoroughly utilized within teams internally and client-side. Collaborated with art directors, project managers, and designers to develop websites, landing pages, and electronic direct mail campaigns in Sitecore and Umbraco. Also a core contributor to project bids, either creating high-fidelity prototypes or strategic microsites for pitches.',
    url: 'http://www.bondinco.com/',
    logo: 'http://bondinco.com/wp-content/uploads/2015/11/bondinco-header22.png'
  }, {
    label: 'Jump into the code',
    year: 'Jan 2012',
    title: 'VirtueNetz',
    subtitle: 'Frontend developer & UX / UI Designer',
    description: 'I have worked on a multitude of web and print based projects for a range of clients providing Web Design (Photoshop, Illustrator, InDesign) and Development (PHP, HTML, CSS, LESS, JS, jQuery, WordPress, WooCommerce, Bootstrap, Responsive Layouts), eCommerce Solutions, Corporate Branding and Graphic Design. I have a keen understanding of wireframes, sitemaps and user experience design which I put to good use on every project I work on.',
    url: 'http://www.virtuenetz.com/',
    logo: 'http://bondinco.com/wp-content/uploads/2015/11/bondinco-header22.png'
  }, {
    label: 'Imrpove UX / UI',
    year: 'Apr 2011',
    title: 'ConceptBeans',
    subtitle: 'UX / UI Designer',
    description: 'Lead UI developer responsible for builds in Angular and Adobe Experience Manager. Subscribed to modern workflows including automation via grunt, BEM implementation via SASS, and version control via Git. Trained in agile by AgencyAgile and thoroughly utilized within teams internally and client-side. Collaborated with art directors, project managers, and designers to develop websites, landing pages, and electronic direct mail campaigns in Sitecore and Umbraco. Also a core contributor to project bids, either creating high-fidelity prototypes or strategic microsites for pitches.',
    url: 'http://www.bondinco.com/',
    logo: 'http://bondinco.com/wp-content/uploads/2015/11/bondinco-header22.png'
  }, {
    label: 'My first company',
    year: 'Feb 2011',
    title: 'Mars Multimedia',
    subtitle: 'UI Designer',
    description: 'Joined as Junior UI Designer and learned basics of web design as well as the ability to communicate with team members and clients while effectively meeting milestones and deadlines. ',
    url: 'http://www.bondinco.com/',
    logo: 'http://bondinco.com/wp-content/uploads/2015/11/bondinco-header22.png'
  }
];

class Experience extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetails: false,
      details: experience[0]
    };
    this.showDetails = this.showDetails.bind(this)
  }

  showDetails(props) {
    this.setState({
      showDetails: true,
      details: experience[props]
    });
  }

  render() {
    return (
      <div className="app">
        <h1 className="app-heading">Experience</h1>
        <p className="app-paragraph">The only source of knowledge is experience.</p>

        <div className="tabs">
          <TabsContent data={this.state.details} />

          <Tabs data={experience} showDetails={this.showDetails} />
        </div>
      </div>
    );
  }
}

export default Experience;



// WEBPACK FOOTER //
// ./src/Pages/Experience.js